import { registerFunctionLoggedInExecuteOnce } from '../../../CORE/src/front/LoggedInExecuteOnceServiceBase'

const unconfirmedFeedbackFilter = () => ({
  _or: [{ is_confirmed: { _eq: false } }, { is_confirmed: { _null: true } }],
})

export const hasUnconfirmedServiceLevelFeedbacks = async (): Promise<boolean> => {
  const model = $core.$models?.yhc_service_level_feedbacks
  if (!model) {
    return false
  }
  try {
    const rows = await model.find({
      filter: unconfirmedFeedbackFilter(),
      limit: 1,
      fields: ['id'],
    })
    return Array.isArray(rows) && rows.length > 0
  } catch (e) {
    console.warn(
      '[YHC] 未確認の質問・要望の取得に失敗しました。管理ロールの read 権限を確認してください。',
      e,
    )
    return false
  }
}

const openUnconfirmedFeedbackModal = () => {
  $core.$modals.openModal({
    modalId: 'yhc-unconfirmed-service-level-feedbacks',
    modalProps: {
      title: '未確認の質問・要望があります',
      okOnly: true,
      okTitle: '閉じる',
      noCloseOnBackdrop: true,
      noCloseOnEsc: true,
      centered: true,
    },
    component: {
      template: `
        <div class="yhc-unconfirmed-feedback-modal">
          <p class="mb-0">
            <a href="#" class="fw-bold" @click.prevent="goToList">質問・要望一覧を開く</a>
          </p>
        </div>
      `,
      methods: {
        goToList() {
          $core.$modals.closeModal('yhc-unconfirmed-service-level-feedbacks')
          $core.$router.push('/m/yhc_service_level_feedbacks')
        },
      },
    },
  })
}

/**
 * 管理画面ログイン時（トークン復元含む）に未確認投稿があれば強制モーダルを表示
 */
export const registerUnconfirmedServiceLevelFeedbackModal = () => {
  registerFunctionLoggedInExecuteOnce({
    appHookFunctionRegisterKey: 'yhcUnconfirmedServiceLevelFeedbacksModal',
    useAwaitOnLoad: true,
    hookPriority: 5000,
    onceLoadFunction: async (userData) => {
      if (!userData) return
      const hasUnconfirmed = await hasUnconfirmedServiceLevelFeedbacks()
      if (hasUnconfirmed) {
        openUnconfirmedFeedbackModal()
      }
    },
  })
}
